import { render, staticRenderFns } from "./iItemData.vue?vue&type=template&id=546e4dce&scoped=true&"
import script from "./iItemData.vue?vue&type=script&lang=js&"
export * from "./iItemData.vue?vue&type=script&lang=js&"
import style0 from "./iItemData.vue?vue&type=style&index=0&id=546e4dce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e4dce",
  null
  
)

export default component.exports